import compareVersions from 'compare-versions'

import { Device } from './device'

/**
 * 在快手APP中判断是否安装快影
 * @return {Promise<T>}
 */
export function ksHasInstalledKwai(identifier) {
  const device = new Device()
  const identifierTmp = device.isIOS ? 'kwaiying' : 'com.kwai.videoeditor'
  return new Promise((resolve) => {
    try {
      window.ksBridge.hasInstalledApp({
        identifier: identifier || identifierTmp,
        success(data) {
          if (data && data.result === 1) {
            resolve(true)
          } else {
            resolve(false)
          }
        },
        fail() {
          resolve(false)
        },
      })
    } catch (e) {
      resolve(false)
    }
  })
}

export async function openKwaiying(schema) {
  const device = new Device()
  let hasInstalledKy = false
  const url = device.isIOS
    ? 'https://itunes.apple.com/cn/app/id1195860596'
    : 'market://details?id=com.kwai.videoeditor'
  if (device.isIOS) {
    const [res1, res2] = await Promise.all([
      ksHasInstalledKwai('kwaiying'),
      ksHasInstalledKwai('kwaiying1024'),
    ])
    if (res1 || res2) {
      hasInstalledKy = true
    }
  } else {
    hasInstalledKy = await ksHasInstalledKwai('com.kwai.videoeditor')
  }
  let openStatus = false
  const { property, eventName } = getEventProperty()
  // page 事件处理函数
  const pageChange = function pageChange(e) {
    if (
      document[property] ||
      e.hidden ||
      document.visibilityState === 'hidden'
    ) {
      openStatus = true
    }
    document.removeEventListener(eventName, pageChange)
  }
  document.addEventListener(eventName, pageChange, false)
  if (hasInstalledKy) {
    window.location.href = schema
  } else if (device.isIOS && compareVersions(device.iosVersion, '15.0') >= 0) {
    // Toast.loading('跳转中')
    window.location.href = schema
    setTimeout(function () {
      if (openStatus) {
        return
      }
      document.removeEventListener(eventName, pageChange)
      window.location.href = url
    }, 2000)
  } else {
    window.location.href = url
  }
}

function getEventProperty() {
  let property = 'hidden'
  let eventName = 'visibilitychange'

  // visibilitychange 事件名称
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    property = 'hidden'
    eventName = 'visibilitychange'
  } else if (typeof document.msHidden !== 'undefined') {
    property = 'msHidden'
    eventName = 'msvisibilitychange'
  } else if (typeof document.webkitHidden !== 'undefined') {
    property = 'webkitHidden'
    eventName = 'webkitvisibilitychange'
  }
  return { property, eventName }
}
/**
 * 获取快手Webview中的deviceInfo
 * @return {Promise<T>}
 */
export function getKsDeviceInfo() {
  return new Promise((resolve) => {
    try {
      window.ksBridge.getDeviceInfo({
        success: (result) => {
          resolve(result.data)
        },
        fail: () => {
          resolve({})
        },
      })
    } catch (e) {
      resolve({})
    }
  })
}

export function compareVersion(target) {
  const device = new Device()
  if (!device.appVersion) return false
  return compareVersions(target, device.appVersion || '1.1') > 0
}
